module.exports = __webpack_public_path__ + "files/41ae95517b4f3ee712b43dfae7737232.png";